import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    columnHeader: {
        color: theme.palette.primary.dark,
        "&.MuiTypography-root": {
            fontSize: "12px",
        },
    },
    waiting: {
        color: theme.palette.error.main,
        fontStyle: "italic",
        "&.MuiTypography-root": {
            fontSize: "14px",
        },
    },
    toBeDefined: {
        fontStyle: "italic",
        "&.MuiTypography-root": {
            fontSize: "14px",
        },
    },
    notApplicable: {
        display: "flex",
        gap: "5px",
        alignItems: "center",
        fontStyle: "italic",
        "&.MuiTypography-root": {
            fontSize: "14px",
        },
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            background: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            borderBottom: "1px solid rgba(193, 200, 218, 1)",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Source Sans 3",
            paddingBottom: theme.spacing(1),
        },
    },
}));
